/* eslint-disable no-param-reassign */
// open external links in new tab

const checkIfFile = (url) => {
  url = new URL(url);
  return url.pathname.split('/').pop().indexOf('.') > 0;
};

function openExternalLink() {
  window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('a[href]').forEach((item) => {
      if (window.location.hostname !== new URL(item.href).hostname || checkIfFile(item.href)) {
        item.target = '_blank';
        item.rel = 'noreferrer nofollow noopener';
      }
    });
  });
}

openExternalLink();
